/**
 * @module Landing
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CONTENT_ENDPOINT } from '@core/aem/content-endpoints';
import { PDLBaseComponent } from '@experience/reb-pdl/components/pdl.base.component';
import { PdlService } from '@experience/reb-pdl/services/pdl.service';
import { ActivatedRoute } from '@angular/router';

/**
 * Home component representing the Home page
 * @channel shared
 */
@Component({
  selector: 'tmo-home',
  templateUrl: './home.component.html',
})
export class HomeComponent extends PDLBaseComponent implements OnInit, OnDestroy {
  /**
   * Stores the string value for the AEM Id
   */
  public aemId: string;
  constructor(
    public pdlService: PdlService,
    public route: ActivatedRoute
  ) {
    super(pdlService, route);
    this.aemId = CONTENT_ENDPOINT.HOME;
  }
  /**
   * Loads the initial configuration for creating the home component
   * @returns void
   */
  public ngOnInit(): void {
    super.ngOnInit();
  }
  /**
   * Destroys them configuration for the home component
   * @returns void
   */
  public ngOnDestroy(): void {
    super.ngOnDestroy();
  }
  /**
   * Protected method to get the aemId
   * @returns string
   */
  protected getId(): string {
    return this.aemId;
  }
}
